// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Legacy redirect route for /items/{itemKey}/units.
 * Redirects to /catalog/items/{itemKey}/units.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/items/$itemKey/units')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/catalog/items/$itemKey/units',
      params: { itemKey: params.itemKey },
      search: true,
    });
  },
});
